<template>
  <div>
    <v-form v-model="valid" ref="form" lazy-validation @submit="reset">
      <v-container class="pt-0">
        <span class="headline">{{$t('resendVerification.title')}}</span>
        <v-row>
          <v-col>
            <v-text-field
              ref="email"
              v-model="email"
              type="email"
              :disabled="loading"
              :rules="emailRules"
              autocomplete="username"
              prepend-icon="mdi-account"
              :label="$t('common.email-address')"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-btn
              type="submit"
              color="primary"
              class="mr-4"
              :disabled="!valid || loading || !filled"
              :loading="loading"
            >
              <v-icon left>mdi-email</v-icon>{{$t('resendVerification.request-link')}}
            </v-btn>
          </v-col>
          <v-col>
            <v-btn class="mr-4" :disabled="loading" link :to="'/login' + ($route.query.redirect ? '?redirect=' + encodeURIComponent($route.query.redirect) : '')">
              <v-icon left>mdi-login</v-icon>{{$t('resendVerification.back-to-login')}}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="successMessage">
          <v-col>
            <v-card>
              <v-card-text class="success">
                <span>
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                  &nbsp;{{successMessage}}
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import {} from "@/plugins/store.js";

export default {
  name: "ResendVerification",
  data: () => ({
    valid: false,
    loading: false,
    successMessage: undefined,
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    error: undefined
  }),

  mounted() {
    this.email = this.$store.state.auth.emailAddress;
  },

  beforeDestroy() {},

  computed: {
    filled() {
      return this.email && this.email.length > 0;
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset(e) {
      e.preventDefault();
      this.loading = true;
      this.successMessage = undefined;
      console.log("Requesting e-mail...");
      this.$api.resendVerificationEMail(this.email)
        .then(response => {
          this.loading = false;
          console.log(response);
          this.resetForm();
          this.successMessage = "Anfrage erfolgreich. Du erhältst in den nächsten Minuten eine E-Mail mit dem Link. Bitte prüfe zudem ob die E-Mail im Spam Ordner abgelegt wurde.";
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
      return false;
    },
    resetForm() {
      this.error = undefined;
      this.successMessage = undefined;
      this.$refs.form.reset();
    }
  }
};
</script>
